import { createAction } from "redux-actions";
import { SET_LOYALTY_TIER } from "../constants";

const setLoyaltyTier = createAction(SET_LOYALTY_TIER, tier => tier);

export default setLoyaltyTier;
